import { create } from 'zustand';

import { IStoryMeta } from 'types/story';

export type TStoryMode = 'editor' | 'view' | 'preview' | 'poster';

interface IStoryState {
  id: string;
  mode?: TStoryMode;
  meta: IStoryMeta | null;
}

const DEFAULT_STATE: IStoryState = {
  id: '',
  mode: undefined,
  meta: null,
};

interface IStoryStateStore extends IStoryState {
  setStoryState: (state: IStoryState) => void;
  resetStoryState: () => void;
}

export const useStoryStateStore = create<IStoryStateStore>(
  set => ({
    ...DEFAULT_STATE,
    setStoryState: state => set(state),
    resetStoryState: () => set(DEFAULT_STATE),
  })
);
